import { apiPost } from './index'

export type EntitlementGrantPayload = {
  subject_type: 'user' | 'station'
  subject_id: number
  feature_key: string
  expires_at?: string
  note?: string
}

export type EntitlementGrantResponse = {
  subject_type: 'user' | 'station'
  subject_id: number
  feature_key: string
  expires_at: string | null
  note: string | null
  source: 'grant'
}

export type CreditGrantPayload = {
  owner_type: 'user' | 'station'
  owner_id: number
  bucket: 'included' | 'subscription' | 'pack' | 'manual'
  amount: number
  expires_at?: string
  note?: string
}

export type CreditGrantResponse = {
  owner_type: 'user' | 'station'
  owner_id: number
  bucket: string
  amount: number
  expires_at: string | null
  note: string | null
}

export function grantEntitlement(payload: EntitlementGrantPayload): Promise<EntitlementGrantResponse> {
  return apiPost<EntitlementGrantResponse>('superadmin/entitlements/grant', payload)
}

export function grantCredits(payload: CreditGrantPayload): Promise<CreditGrantResponse> {
  return apiPost<CreditGrantResponse>('superadmin/credits/grant', payload)
}
